import React, { useEffect, useRef, useState } from 'react';
import { Camera, X } from 'lucide-react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import './BarcodeScanner.css';

const BarcodeScanner = ({ onScan, onClose }) => {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const [status, setStatus] = useState('Starting camera...');
  const [error, setError] = useState('');

  useEffect(() => {
    let isActive = true;
    const reader = new BrowserMultiFormatReader();

    const stopScanner = () => {
      if (controlsRef.current) {
        controlsRef.current.stop();
        controlsRef.current = null;
      }
    };

    const startScanner = async () => {
      if (!navigator.mediaDevices?.getUserMedia) {
        setError('Camera access is not available. Use HTTPS or localhost, then try again.');
        return;
      }

      try {
        setStatus('Point your camera at the barcode.');
        controlsRef.current = await reader.decodeFromConstraints(
          {
            audio: false,
            video: {
              facingMode: { ideal: 'environment' },
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          },
          videoRef.current,
          (result) => {
            if (!isActive || !result) {
              return;
            }

            const scannedValue = result.getText();
            if (scannedValue) {
              onScan(scannedValue);
              stopScanner();
            }
          }
        );
      } catch (cameraError) {
        setError('Camera permission was denied or unavailable. Allow camera access, make sure the site is using HTTPS, then try again.');
      }
    };

    startScanner();

    return () => {
      isActive = false;
      stopScanner();
    };
  }, [onScan]);

  return (
    <div className="barcode-scanner" role="dialog" aria-modal="true" aria-label="Barcode scanner">
      <div className="barcode-scanner-panel">
        <div className="scanner-header">
          <div className="scanner-title">
            <Camera size={18} />
            Scan Barcode
          </div>
          <button type="button" className="scanner-close-button" onClick={onClose} aria-label="Close scanner">
            <X size={20} />
          </button>
        </div>

        <div className="scanner-video-wrap">
          <video ref={videoRef} className="scanner-video" playsInline muted />
          <div className="scanner-target" />
        </div>

        <p className={error ? 'scanner-message error' : 'scanner-message'}>
          {error || status}
        </p>
      </div>
    </div>
  );
};

export default BarcodeScanner;
